import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Github = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#github_clip0_439_72503)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9638 0.000610352C5.34757 0.000610352 -0.000976562 5.28929 -0.000976562 11.8321C-0.000976562 17.0621 3.42602 21.4892 8.18017 23.0561C8.77456 23.1739 8.99229 22.8015 8.99229 22.4883C8.99229 22.214 8.9727 21.2738 8.9727 20.2942C5.6444 20.9995 4.95131 18.8838 4.95131 18.8838C4.41643 17.5126 3.62391 17.1602 3.62391 17.1602C2.53456 16.4354 3.70326 16.4354 3.70326 16.4354C4.91163 16.5138 5.5457 17.6499 5.5457 17.6499C6.61521 19.4519 8.33863 18.9427 9.03196 18.6292C9.13091 17.8653 9.44806 17.3364 9.78481 17.0426C7.13025 16.7684 4.33732 15.7498 4.33732 11.2052C4.33732 9.91231 4.81244 8.85458 5.56529 8.03195C5.44651 7.73818 5.03041 6.52347 5.68432 4.89768C5.68432 4.89768 6.69456 4.58421 8.97245 6.11216C9.9477 5.85317 10.9535 5.72142 11.9638 5.72031C12.974 5.72031 14.0038 5.85758 14.9548 6.11216C17.233 4.58421 18.2432 4.89768 18.2432 4.89768C18.8971 6.52347 18.4808 7.73818 18.362 8.03195C19.1347 8.85458 19.5902 9.91231 19.5902 11.2052C19.5902 15.7498 16.7973 16.7486 14.1229 17.0426C14.5588 17.4148 14.935 18.1199 14.935 19.2365C14.935 20.8231 14.9154 22.0965 14.9154 22.4881C14.9154 22.8015 15.1334 23.1739 15.7275 23.0564C20.4817 21.489 23.9087 17.0621 23.9087 11.8321C23.9282 5.28929 18.5601 0.000610352 11.9638 0.000610352Z"
        fill="hsl(from hsl(0 0% 9%) h s 50%)"
      />
    </g>
    <defs>
      <clipPath id="github_clip0_439_72503">
        <rect
          width="24.001"
          height="23.0779"
          fill="white"
          transform="translate(-0.000976562 0.000610352)"
        />
      </clipPath>
    </defs>
  </svg>
);
